import {createSelector} from "@reduxjs/toolkit";

export const selectFilter = (selectData, selectFiltering, filterProperty) => createSelector(
  selectData,
  selectFiltering,
  (data, filtering) => data.filter(e => !filtering || !e[filterProperty])
);
